<script>
import {useWishlistStore} from "../Stores/WishlistStore";
import _ from "../../Libraries/translations";

export default {
  name: "Heart",
  props: {
    id: String,
    absolute: Boolean,
    type: String,
    title: String,
    price: String,
    category: Object,
    image: String,
    url: String,
    icon: String,
  },
  setup(props) {
    const wishlist = useWishlistStore();
    return {
      wishlist: wishlist,
      item: props,
    }
  },
  methods: {
    toggle() {
      if (this.wishlist.has(this.item.id)) {
        this.wishlist.remove(this.item.id);
      } else {
        this.wishlist.add(this.item);
      }
    }
  },
  computed: {
    isAdded() {
      return this.wishlist.has(this.item.id);
    },
    titleAttr() {
      if (this.isAdded) {
        return _('bookmarks.remove', this.title);
      }
      return _('bookmarks.add', this.title);
    }
  }
}
</script>

<template>
  <span class="wishlist-heart" :class="{'wishlist-heart--absolute': absolute}" @click.prevent="toggle"
        :title="titleAttr">
    <i class="wishlist-heart__icon fa-heart" :class="[
      isAdded ? 'fa-solid': 'fa-thin',
      icon ? `fa-${icon}` : 'fa-heart',
      ]"></i>
  </span>
</template>
